import clsx from "clsx";
import React, { FC } from "react";

type Props = {
  onClick: () => void;
  className?: string;
  ["data-test-id"]?: string;
};

export const SettingIconButton: FC<Props> = ({ onClick, className, "data-test-id": dataTestId }) => {
  return (
    <button
      className={clsx("flex justify-center items-center opacity-75", className)}
      onClick={onClick}
      data-test-id={dataTestId}
    >
      <img src="./img/icon-setting-black.svg" alt="setting" />
    </button>
  );
};
